
import angular from "angular";
import ImplictSearchConnectorTokenFactoryModule from "./ImplicitSearchConnectorTokenFactory";
import TokenFactoriesModule from "../../models/factories/token-factories";
import BinaryTreeModule from "../binary-tree";
import ScopeTokenValues from "../../models/parser-tokens/ScopeTokenValues";
import SearchParsingError from "../../models/errors/SearchParsingError";

const mLogSvc = new WeakMap();
const mImplicitSearchConnectorFactory = new WeakMap();
const mScopeTokenFactorySvc = new WeakMap();
const mBinaryTreeFactory = new WeakMap();

class SearchRequestSyntaxParserService {
    constructor($log, ImplicitSearchConnectorTokenFactory, BinaryTreeFactory, ScopeTokenFactory) {
        mLogSvc.set(this, $log);
        mImplicitSearchConnectorFactory.set(this, ImplicitSearchConnectorTokenFactory("or"));
        mBinaryTreeFactory.set(this, BinaryTreeFactory);
        mScopeTokenFactorySvc.set(this, ScopeTokenFactory);
    }

    _parseUserRequest(tokenizedSearchString) {

        if (!(angular.isArray(tokenizedSearchString))) {
            throw new Error("Search String Parser: Invalid parameter, must be an array of request tokens");
        }

        let searchParseTree = mBinaryTreeFactory.get(this).buildTree(null);
        let currentParseTreeNode = searchParseTree.root;
        let parenRootNode = undefined;

        tokenizedSearchString.forEach((token) => {

            let currentTokenType = token.tokenType;
            switch(currentTokenType) {
                case "opToken":
                    searchParseTree.moveToLeftChild(currentParseTreeNode, token);
                    currentParseTreeNode = currentParseTreeNode.parent;
                    currentParseTreeNode = searchParseTree.insertAsRightChild(currentParseTreeNode, null);
                    break;
                case "valueToken":
                    if (currentParseTreeNode.data == null) {
                        currentParseTreeNode.data = token;
                    }
                    else {
                        let implicitSearchConnectorToken = mImplicitSearchConnectorFactory.get(this).getConnectorToken();
                        searchParseTree.moveToLeftChild(currentParseTreeNode, implicitSearchConnectorToken);
                        currentParseTreeNode = currentParseTreeNode.parent;
                        currentParseTreeNode = searchParseTree.insertAsRightChild(currentParseTreeNode, token);
                    }

                    break;
                case "scopeToken":

                    switch (token.tokenParams.scopeType) {
                        case ScopeTokenValues.BeginScope:
                            currentParseTreeNode = searchParseTree.moveToLeftChild(currentParseTreeNode, token);
                            break;

                        case ScopeTokenValues.EndScope:
                            parenRootNode = searchParseTree.findParentWithValue(currentParseTreeNode, function(tgtToken) {
                                if (tgtToken == null) {
                                    return false;
                                }

                                if (tgtToken.tokenType === "scopeToken") {
                                    return (tgtToken.tokenParams.scopeType === ScopeTokenValues.BeginScope);
                                }

                                return false;
                            });

                            if (parenRootNode != null) {
                                parenRootNode.data = mScopeTokenFactorySvc.get(this).buildClosedScopeToken();
                                currentParseTreeNode = parenRootNode;
                                parenRootNode = undefined;
                            }
                            else {
                                throw new SearchParsingError("Encountered mis-matched closing parentheses.");
                            }
                            break;

                        case ScopeTokenValues.ClosedScope:
                            throw new SearchParsingError("Encountered Closed Scope Token in Token Stream.");

                        default:
                            throw new SearchParsingError("Encountered Unexpected Scope Token Type in Token Stream.");
                    }

                    break;

                default:
                    throw new SearchParsingError("Encountered unknown token type");
            }

        });

        mLogSvc.get(this).debug("Exiting Search String Parser Tree Builder.");
        mLogSvc.get(this).debug(searchParseTree);

        return searchParseTree;
    }

    _buildSearchRequestFromParsedTree(searchRequestTree) {
        let searchRequest = searchRequestTree.walkTree(function(currentToken, childRequests) {
            if (currentToken != null) {
                return currentToken.toSearchRequest(childRequests);
            }
            else {
                return null;
            }

        });

        return searchRequest;
    }

    _buildSearchRequestFromTokenizedSearchString(tokenizedSearchString) {
        let resultTree = this._parseUserRequest(tokenizedSearchString);
        let searchRequestRoot = this._buildSearchRequestFromParsedTree(resultTree);
        return searchRequestRoot;
    }

    toString() {
        return "SearchRequestSyntaxParserService";
    }

    parseTokenizedSearchString(tokenizedSearchString) {
        return this._buildSearchRequestFromTokenizedSearchString(tokenizedSearchString);
    }
}

SearchRequestSyntaxParserService.$inject = [
    "$log",
    "ImplicitSearchConnectorTokenFactory",
    "BinaryTreeFactory",
    "ScopeTokenFactory"
];

export default angular
    .module("trackerbase-app.services.search-request-parser.search-request-syntax-parser-service", [
        ImplictSearchConnectorTokenFactoryModule,
        TokenFactoriesModule,
        BinaryTreeModule
    ])
    .service("SearchRequestSyntaxParserService", SearchRequestSyntaxParserService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/search-request-parser/SearchRequestSyntaxParserService.js
// module id = +vP5
// module chunks = 1